import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section aria-labelledby="guarantee-title" className="bg-sand py-16 md:py-24" data-id="element-88" data-mp="3iynspn5gstce">
      <div className="mx-auto flex max-w-2xl flex-col items-center px-5 text-center" data-id="element-89" data-mp="srkdbfr09yl">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-paper" data-id="element-90" data-mp="qerw4cd6h7a">
          <ShieldCheckIcon className="h-8 w-8 text-primary" strokeWidth={1.75} aria-hidden="true" data-id="element-91" data-mp="3s15e5zdaphyc" />
        </span>
        <h2 id="guarantee-title" className="mt-6 font-serif text-3xl uppercase leading-[1.15] tracking-wide text-ink md:text-[2.6rem]" data-id="element-92" data-mp="5rudbxigepq7">
          Probalo sin riesgo durante 7 días
        </h2>
        <p className="mt-5 text-lg leading-relaxed text-muted" data-id="element-93" data-mp="jl3hnjrjol1v">
          Si el material no es lo que esperabas, podés solicitar el reembolso dentro de los 7 días posteriores a tu
          compra, de acuerdo con nuestra política de devoluciones.
        </p>
        <a href="#" className="mt-6 border-b-2 border-ink pb-0.5 text-[15px] font-bold text-ink transition-colors duration-150 hover:border-primary hover:text-primary" data-id="element-94" data-mp="ojn4dmdyq0va">
          Política de reembolso completa
        </a>
      </div>
    </section>;
}